import React, { useMemo } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { Container } from 'react-grid-system';

import { useApp } from '../../_libs/hooks/useApp';
import { useBrand } from '../../_libs/hooks/useBrand';
import { useData } from '../../_libs/hooks/useData';
import { usePdfUrl } from '../../_libs/hooks/usePdfUrl';

import PdfUrlProvider from '../../_libs/pdfUrl/provider';

import Navigation from '../../molecules/Navigation';
import PDFLoader from '../../organisms/PDFLoader';
import ShareForm from '../../organisms/ShareForm';
import ErrorBoundary from '../../organisms/ErrorBoundary';

import RadianPDF from './RadianPDF';

//
const PDFViewerHelper = (): JSX.Element => {
  const {
    radius,
    zipCode,
    reportData: appReportData,
  } = useApp();
  const {
    isCoBranded,
    coBrand,
    lbBrand,
    primaryBrand,
  } = useBrand();
  const {
    reportData,
    featureLogicData,
    themeData,
    topThemes,
    topRaceEthnicities,
  } = useData();
  const {
    setPdfBlob,
    pdfBlob,
  } = usePdfUrl();

  const pdfProps = {
    lbBrand,
    coBrand,
    featureLogicData,
    isCoBranded,
    primaryBrand,
    radius,
    reportData,
    themeData,
    topRaceEthnicities,
    topThemes,
    uuid: appReportData.uuid,
    zipCode,
    setPdfBlob,
    pdfBlob,
  };
  const PDF = useMemo(() => { return <RadianPDF {...pdfProps} />; }, []);
  return (
    <div
      id="js-pdf-container"
      style={{
        width: '100%',
        height: '80vh',
        display: 'none',
      }}
    >
      <PDFViewer
        className="mt-4 mb-4"
        style={{
          width: '100%',
          height: '100%',
        }}
        showToolbar={false}
      >
        { PDF }
      </PDFViewer>
    </div>
  );
};

const Viewer = (): JSX.Element => {
  return (
    <ErrorBoundary>
      <Navigation />
      <Container>
        <PdfUrlProvider>
          <PDFLoader />
          <PDFViewerHelper />
          <ShareForm />
        </PdfUrlProvider>
      </Container>
    </ErrorBoundary>
  );
};

export default Viewer;
